/**
 * Accessible message rotation for the editorial notice bar.
 * Each section instance owns its timers and Theme Editor lifecycle.
 */
(function () {
  'use strict';

  var selector = '[data-editorial-promo-bar]';
  var stateByRoot = new WeakMap();

  function findRoots(scope) {
    var roots = [];
    if (!scope) return roots;

    if (scope.nodeType === 1 && scope.matches && scope.matches(selector)) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll(selector), function (root) {
        roots.push(root);
      });
    }

    return roots;
  }

  function initRoot(root) {
    if (!root || stateByRoot.has(root)) return;

    var messages = Array.prototype.slice.call(root.querySelectorAll('[data-promo-message]'));
    var previousButton = root.querySelector('[data-promo-prev]');
    var nextButton = root.querySelector('[data-promo-next]');
    var activeIndex = Math.max(0, messages.findIndex(function (message) {
      return message.classList.contains('is-active');
    }));
    var timer = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setInteractiveState(message, isActive) {
      message.classList.toggle('is-active', isActive);
      message.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      if (message.matches('a, button')) {
        if (isActive) {
          message.removeAttribute('tabindex');
        } else {
          message.setAttribute('tabindex', '-1');
        }
      }
    }

    function show(index) {
      if (!messages.length) return;
      activeIndex = (index + messages.length) % messages.length;
      messages.forEach(function (message, messageIndex) {
        setInteractiveState(message, messageIndex === activeIndex);
      });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (reducedMotion || messages.length < 2 || root.dataset.autoRotate !== 'true') return;

      var seconds = Math.max(4, parseInt(root.dataset.rotationSpeed, 10) || 7);
      timer = window.setInterval(function () {
        show(activeIndex + 1);
      }, seconds * 1000);
    }

    function previous() {
      show(activeIndex - 1);
      start();
    }

    function next() {
      show(activeIndex + 1);
      start();
    }

    function pauseOnFocus(event) {
      if (root.contains(event.target)) stop();
    }

    function resumeAfterFocus(event) {
      if (!root.contains(event.relatedTarget)) start();
    }

    function handleVisibility() {
      if (document.hidden) stop();
      else start();
    }

    if (messages.length < 2) {
      if (previousButton) previousButton.hidden = true;
      if (nextButton) nextButton.hidden = true;
    }

    show(activeIndex);
    if (previousButton) previousButton.addEventListener('click', previous);
    if (nextButton) nextButton.addEventListener('click', next);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', pauseOnFocus);
    root.addEventListener('focusout', resumeAfterFocus);
    document.addEventListener('visibilitychange', handleVisibility);
    start();

    stateByRoot.set(root, {
      showMessage: function (message) {
        var index = messages.indexOf(message);
        if (index >= 0) {
          stop();
          show(index);
        }
      },
      destroy: function () {
        stop();
        if (previousButton) previousButton.removeEventListener('click', previous);
        if (nextButton) nextButton.removeEventListener('click', next);
        root.removeEventListener('mouseenter', stop);
        root.removeEventListener('mouseleave', start);
        root.removeEventListener('focusin', pauseOnFocus);
        root.removeEventListener('focusout', resumeAfterFocus);
        document.removeEventListener('visibilitychange', handleVisibility);
      }
    });
  }

  function init(scope) {
    findRoots(scope || document).forEach(initRoot);
  }

  function destroy(scope) {
    findRoots(scope || document).forEach(function (root) {
      var state = stateByRoot.get(root);
      if (!state) return;
      state.destroy();
      stateByRoot.delete(root);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var message = event.target && event.target.closest ? event.target.closest('[data-promo-message]') : null;
    var root = message && message.closest(selector);
    var state = root && stateByRoot.get(root);
    if (state && message) state.showMessage(message);
  });

  init(document);
})();
